var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper background-grey"},[_c('ProjectStats',{attrs:{"submissions":_vm.submissions,"forms":_vm.forms,"daily":_vm.daily,"loaded":_vm.loaded}}),_c('FormBoxes')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }